import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SigteApp from './sigte/SigteApp';
import SigtePlatformApp from './sigte/SigtePlatformApp';
import reportWebVitals from './reportWebVitals';

// SIGTE (tenant) y SIGTE-admin (plataforma) son sistemas separados de
// Kofides contable, y separados entre si (tablas/auth propias cada uno). Se
// distinguen por pathname, sin agregar react-router. /sigte/admin se revisa
// ANTES que /sigte porque tambien hace match con startsWith('/sigte').
const pathname = window.location.pathname;
const isSigteAdmin = pathname.startsWith('/sigte/admin');
const isSigte = !isSigteAdmin && pathname.startsWith('/sigte');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isSigteAdmin ? <SigtePlatformApp /> : (isSigte ? <SigteApp /> : <App />)}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
